import styled from "styled-components";

export const Button = styled.button`
  background-color: ${(props) => props.theme.pallet.primary};
  border-radius: 20px;
  border-color: ${(props) => props.theme.pallet.primary};
  color: white;
  cursor: pointer;
  height: 40px;
`;
